import apiClient from '@/axios';

export const fetchNews = (params = {}) => {
  return apiClient.get('news', { params });
};

export const fetchNewsItem = (id) => {
  return apiClient.get(`/admin/news/${id}`);
};

export const createNews = (body, visible = true) => {
  return apiClient.post('/admin/news', { body, visible });
};

export const updateNews = (id, payload) => {
  return apiClient.post(`/admin/news/${id}`, payload);
};

export const setNewsVisibility = (id, visible) => {
  return apiClient.post(`/admin/news/${id}/visibility`, { visible });
};

export const deleteNews = (id) => {
  return apiClient.delete(`/admin/news/${id}`);
};
